var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: { timeout: 30000, top: true, color: _vm.toastColor },
              model: {
                value: _vm.toastEnable,
                callback: function($$v) {
                  _vm.toastEnable = $$v
                },
                expression: "toastEnable"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.toastText) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.toastEnable = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n      " + _vm._s(tabItem) + "\n    ")
            ])
          }),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(2, function(item, index) {
              return _c("v-tab-item", { key: "item" + index }, [
                _vm.tab === 0 && index === 0
                  ? _c(
                      "div",
                      [
                        _c("UpcMainTabItem", {
                          on: {
                            showToast: _vm.showToast,
                            showAddUpcDialog: _vm.showAddUpcDialog
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === 1 && index === 1
                  ? _c("div", [_c("PricingPlan")], 1)
                  : _vm._e()
              ])
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.addUpcDialog
        ? _c("InboundAddUpcPopup", {
            attrs: { hasMultiple: "" },
            model: {
              value: _vm.addUpcDialog,
              callback: function($$v) {
                _vm.addUpcDialog = $$v
              },
              expression: "addUpcDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eefd1b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eefd1b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upc.vue
// module id = null
// module chunks = 